'use strict';

angular.module('chatEngine.docs', [])
.controller('DocsCtrl', ['$scope', '$routeParams', '$timeout', '$location', '$window',
function($scope, $routeParams, $timeout, $location, $window) {

    $scope.includedFile = 'views/docs/' + $routeParams.file + '.html';
    $scope.fileLoaded = false;

    $scope.onFileLoaded = function() {
        $scope.fileLoaded = true;
        // This function is defined in the scrollTo directive
        $scope.goTo($routeParams.file, $location.hash());
    };

    $scope.codeBlockLangs = {};
    $scope.codeBlocks = {};
    $scope.codeGlobal = '';

    $scope.addLang = function(block, lang) {
        $scope.codeBlockLangs[block] = $scope.codeBlockLangs[block] || [];

        if ($scope.codeBlockLangs[block].indexOf(lang) === -1) {
            $scope.codeBlockLangs[block].push(lang);
        }
        $scope.codeBlocks[block] = $scope.codeBlockLangs[block][0];
    };

    $scope.checkLang = function(block, lang) {
        $scope.codeBlockLangs[block] = $scope.codeBlockLangs[block] || [];

        if ($scope.codeBlockLangs[block].indexOf($scope.codeGlobal) !== -1) {
            return $scope.codeGlobal === lang;
        }
        return $scope.codeBlocks[block] === lang;
    };

    $scope.setLang = function(block, lang) {
        var firstPos = $('#' + block).offset().top;

        $scope.codeBlocks[block] = lang;
        $scope.codeGlobal = lang;
        $timeout(function() {
            var newPos = $('#' + block).offset().top;
            var difference = newPos - firstPos;

            $window.scrollBy(0, difference);
        }, 30);
    };
}]);
